
// http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements

module.exports = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
};


//////////////////
// WEBPACK FOOTER
// ../~/snabbdom-to-html/lib/void-elements.js
// module id = 494
// module chunks = 0